// extracted by mini-css-extract-plugin
export default {"containprod":"KE","containprod2":"LE","title":"ME","servings":"NE","recommendation":"OE","image":"PE","flavorswrap":"QE","flavorsgroupwrap":"RE","moredetailsWrap":"SE","infoWrap":"TE","price":"UE","regularPrice":"VE","netPrice":"WE","addtocartcontainer":"XE","error":"YE"};
    if(module.hot) {
      // 1738064241668
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  